import { useTranslation } from 'react-i18next';
import { S, DataCard, formatCurrency, formatDate } from '../../regureStyles';

const AssociatedClients = ({ associatedClients }) => {
  const { t } = useTranslation();
  const headers = [
    t('screens.brokers.associatedColClientName',  { defaultValue: 'Client Name' }),
    t('screens.brokers.associatedColPolicies',    { defaultValue: 'Policies' }),
    t('screens.brokers.associatedColPremium',     { defaultValue: 'Total Annual Premium' }),
    t('screens.brokers.associatedColLastActivity',{ defaultValue: 'Last Activity' }),
  ];
  return (
    <DataCard>
      <div style={{ fontSize: 14, fontWeight: 700, color: S.textPrimary, marginBottom: 14 }}>{t('screens.brokers.associatedClientsTitle', { defaultValue: 'Associated Clients' })}</div>
      {associatedClients.length === 0 ? (
        <div style={{ padding: '20px 0', textAlign: 'center', color: S.textMuted, fontSize: 13 }}>{t('screens.brokers.associatedEmpty', { defaultValue: 'No associated clients found' })}</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {headers.map(h => (
                <th
                  key={h}
                  style={{
                    padding: '10px 12px',
                    textAlign: 'left',
                    fontSize: 11,
                    fontWeight: 700,
                    color: S.textMuted,
                    textTransform: 'uppercase',
                    letterSpacing: 0.8,
                    borderBottom: `2px solid ${S.borderLight}`,
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {associatedClients.map((c, i) => (
              <tr key={i} style={{ borderBottom: `1px solid ${S.borderLight}`, background: i % 2 === 0 ? '#fff' : S.bgCard }}>
                <td style={{ padding: '11px 12px', fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{c.name}</td>
                <td style={{ padding: '11px 12px', fontSize: 13, color: S.textPrimary }}>{c.policies}</td>
                <td style={{ padding: '11px 12px', fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{formatCurrency(c.totalPremium)}</td>
                <td style={{ padding: '11px 12px', fontSize: 12, color: S.textMuted }}>{c.lastDate ? formatDate(c.lastDate) : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </DataCard>
  );
};

export default AssociatedClients;
